import React, { useCallback, useState } from 'react';

const Header = () => {
  const title = "ХОРЕКА";
  const subtitle = "Текстиль для ресторанов.";
  const phoneNumber = "8 (495) 728-44-37";
  const cleanPhoneNumber = phoneNumber.replace(/\D/g, ''); // Только цифры для копирования
  // Убираем тире, но сохраняем пробелы и скобки
  const displayPhoneNumber = phoneNumber.replace(/-/g, '');
  const [copied, setCopied] = useState(false);

  const handlePhoneClick = useCallback(async () => {
    try {
      // Пробуем скопировать номер в буфер обмена
      await navigator.clipboard.writeText(cleanPhoneNumber);
      
      // Показываем уведомление в Telegram или обычный alert
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.showAlert('Номер скопирован в буфер обмена!');
      } else {
        alert('Номер скопирован в буфер обмена!');
      }
      
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = cleanPhoneNumber;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.showAlert('Номер скопирован!');
      } else {
        alert('Номер скопирован!');
      }
      
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [cleanPhoneNumber]);

  const onRefresh = useCallback(() => {
    console.log("Каталог обновлён");
  }, []);

  return (
    <div className="sticky top-0 z-20 bg-gradient-to-r from-gray-900/95 to-black/95 backdrop-blur-lg border-b border-gray-800">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-lg flex items-center justify-center mr-3 overflow-hidden">
              <img
                src="/logo.png"
                alt="Elite Textile Logo"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const fallback = document.createElement('span');
                  fallback.className = 'text-black font-bold text-sm';
                  fallback.textContent = 'ET';
                  e.currentTarget.parentNode.appendChild(fallback);
                }}
              />
            </div>

            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                {title}
              </h1>
              <p className="text-xs text-gray-400 mt-0.5">
                {subtitle}
              </p>
            </div>
          </div>

          {/* Текстовый телефон в шапке */}
          <div className="flex items-center">
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
              <button
                onClick={handlePhoneClick}
                className={`text-white font-medium text-[13px] transition-colors duration-200 cursor-pointer bg-transparent border-none p-0 ${
                  copied ? 'text-green-400' : 'hover:text-blue-300'
                }`}
                title="Нажмите, чтобы скопировать номер"
              >
                {copied ? 'Скопировано!' : displayPhoneNumber}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;